import { useState } from 'react';
import { uploadAgencyAllocationFile } from '../../allocationServicesAction';
import { ErrMessages } from '../../types';
import { Button, Typography } from '@navi/web-ui/lib/primitives';
import styles from '../index.module.scss';
import logger from '@cp/src/utils/logger';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
import { CLICKSTREAM_EVENT_NAMES } from '@cp/src/service/clickStream.constant';
import { AllocationType } from '@cp/src/pages/AllAgents/UploadHistory/types.ts/types';
import { useDispatch } from 'react-redux';
import { downloadContent } from '@cp/src/utils/commonUtils';
import { allocateCasesSampleCsvFile, deallocateCasesSampleCsvFile } from '../constants/SampleFiles';
import FileUploadContainer from '@cp/src/components/UploadComponent/FileUploadContainer';
import { ErrorMessage } from '@cp/src/components/UploadComponent/UploadComponent';

const AgencyAllocationFileUploadComponent = (props: {
  typeOfAllocation: string;
  setSuccessToast: () => void;
}) => {
  const { typeOfAllocation, setSuccessToast } = props;
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [showLoadingComponent, setShowLoadingComponent] = useState(false);
  const [error, setError] = useState<ErrorMessage>({ message: '', fileName: '' });
  const dispatch = useDispatch();

  const handleSubmitButtonClick = async () => {
    if (uploadedFile) {
      setShowLoadingComponent(true);
      try {
        const response = await uploadAgencyAllocationFile(
          uploadedFile,
          typeOfAllocation.toLowerCase()
        );
        if (response?.success) {
          setUploadedFile(null);
          setError({ message: '', fileName: '' });
          setSuccessToast();
        } else {
          if (response?.message) {
            setError({ message: ErrMessages.UPLOAD, fileName: uploadedFile?.name || '' });
            logger({
              msg: 'Column data/headers are incorrect',
              extras: {
                error: 'Column data/headers are incorrect',
                flow: 'FILED',
                response: response?.message
              },
              type: 'info'
            });
            addClickstreamEvent(
              CLICKSTREAM_EVENT_NAMES.LH_AGENCY_ALLOCATION_FILE_VALIDATION_FAILURE
            );
          }
        }
      } catch (err) {
        logger({
          msg: 'Api call failure',
          extras: {
            error: 'An error occurred while uploading the file',
            flow: 'FILED',
            response: err?.message || ''
          },
          type: 'info'
        });
        setError({
          message: 'An error occurred while uploading the file. Please try again.',
          fileName: uploadedFile?.name || ''
        });
      } finally {
        setShowLoadingComponent(false);
      }
    }
  };

  const handleDownloadClick = () => {
    if (typeOfAllocation === AllocationType.Allocate)
      downloadContent([allocateCasesSampleCsvFile], 'sample_allocate.csv', 'csv');
    else downloadContent([deallocateCasesSampleCsvFile], 'sample_deallocate.csv', 'csv');
  };

  return (
    <div className={styles.card}>
      <Typography className="p-3" variant={'h3'}>
        Select a file
      </Typography>
      <FileUploadContainer
        error={error}
        file={uploadedFile}
        setFile={setUploadedFile}
        setError={setError}
        showLoadingComponent={showLoadingComponent}
        setShowLoadingComponent={setShowLoadingComponent}
        handleDownloadClick={handleDownloadClick}
        styles={styles}
      />
      <div className="flex justify-end pr-3 mt-1">
        <Button
          disabled={!uploadedFile || showLoadingComponent || !!error?.message}
          onClick={handleSubmitButtonClick}
        >
          {typeOfAllocation}
        </Button>
      </div>
    </div>
  );
};

export default AgencyAllocationFileUploadComponent;
